import { render, staticRenderFns } from "./NotenstrukturFach.vue?vue&type=template&id=a128ce48"
import script from "./NotenstrukturFach.vue?vue&type=script&lang=js"
export * from "./NotenstrukturFach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports